// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__+7Ytn","row":"Contacts_row__LiqjM","title":"Contacts_title__xTGN8"};